<template>
    <nav style="--bs-breadcrumb-divider: '';" aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item active fw-bold" aria-current="page"><slot name="pageDetail"></slot></li>
        </ol>
        <ol class="breadcrumb">
            <li class="breadcrumb-item breadcrumb-description"><slot name="pageDescription"></slot></li>
        </ol>
    </nav>
</template>